<div class="c-sidebar__logo">
  <div class="c-sidebar__logo-inner">
    <div class="c-sidebar__logo-text">
      <div class="c-sidebar__logo-title" p500UITooltip [tooltipData]="header?.title">{{ header?.title }}</div>
      <div class="c-sidebar__logo-subtitle">{{ header?.subtitle }}</div>
    </div>
  </div>
  <gtd-hello-widget-sidebar
    [autoInit]="true"
    [subAffiliates]="subAffiliates"
    *ngIf="rbacService.can(RbacPermissionsConstant.WIDGETS_SIDEBAR_WELCOME)"
  ></gtd-hello-widget-sidebar>

  <div class="c-sidebar__logo-menu" [class.-isShow]="isShowMenu"></div>
</div>
<div class="c-sidebar__selector c-sidebar__mobile">
  <p500-ui-applications-selector-mobile class="c-sidebar__application-mobile" [header]="header"> </p500-ui-applications-selector-mobile>
</div>
